<template>
    <div>

        <el-menu :default-active="'1'" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="1">组织对内套餐</el-menu-item>
            <el-menu-item index="2">星舰对内套餐</el-menu-item>
            <el-menu-item index="3">电商对内套餐</el-menu-item>
        </el-menu>

        <br><br>

        <el-button type="primary" class="head-opt" v-if="activeIndex == '1'"  @click="addClickBtn">添加组织对内套餐</el-button>
        <el-button type="primary" class="head-opt" v-if="activeIndex == '2'"  @click="addClickBtn">添加星舰对内套餐</el-button>
        <el-button type="primary" class="head-opt" v-if="activeIndex == '3'"  @click="addClickBtn">添加电商对内套餐</el-button>
            
            <el-table :data="tableData" style="width: 100%" border>

                <el-table-column
                    prop="name"
                    label="名字"
                    width="130">
                </el-table-column>
                
                <el-table-column
                    prop="realPrice"
                    label="现价"
                    width="130">
                </el-table-column>
                
                <el-table-column
                    prop="originalPrice"
                    label="原价"
                    width="130">
                </el-table-column>

                <!-- <el-table-column
                    prop="type"
                    label="类型">
                    <template slot-scope="scope">
                        <div v-if="scope.row.type == 1" >免费版</div>
                        <div v-if="scope.row.type == 2" >企业标准版</div>
                        <div v-if="scope.row.type == 3" >企业旗舰版</div>
                    </template>
                </el-table-column> -->

                <el-table-column
                    prop="status"
                    label="状态">
                    <template slot-scope="scope">

                        <div v-if="scope.row.status == 1" class="yes">启动</div>
                        <div v-if="scope.row.status == 2" class="no">禁用</div>

                    </template>
                </el-table-column>

                <el-table-column
                    prop="walletBalance"
                    label="算力">
                    <template slot-scope="scope">
                        {{ scope.row.walletBalance }}
                    </template>
                    
                </el-table-column>

                <el-table-column
                    prop="years"
                    label="年数">
                </el-table-column>

                <el-table-column
                    prop="agentNumLimit"
                    label="最多坐席数量"
                    v-if="activeIndex=='3'">
                </el-table-column>

                <el-table-column
                    prop="storeNumLimit"
                    label="最多店铺数量"
                    v-if="activeIndex=='3'">
                </el-table-column>

                <el-table-column
                    prop="appNumLimit"
                    label="最多应用数量">
                </el-table-column>
                
                <el-table-column
                    prop="memberNumLimt"
                    label="最多成员数量">
                </el-table-column>

                <el-table-column
                    prop="wordNumLimit"
                    label="最多训练字数">
                </el-table-column>

                <el-table-column
                    prop="yearlyCountLimit"
                    label="一年内使用次数限制"
                    min-width="120">
                </el-table-column>

                <el-table-column
                    fixed="right"
                    label="操作"
                    width="220">
                    <template slot-scope="scope">

                        <el-button @click.stop="editBtn(scope.row)" type="text" size="small">
                            编辑
                        </el-button>

                    </template>
                </el-table-column>
            
            </el-table>

            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNumber"
                :page-sizes="[20, 50, 100, 150]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>

            <AddOrgPruductPay :visible.sync="AddMoneyPayVisible" @ok="getData" ref="AddMoneyPayRef" :curGoodsType="curGoodsType"></AddOrgPruductPay>

    </div>
</template>
  
  
<script>

  import AddOrgPruductPay from "./AddOrgPruductPay.vue"
  
  export default {
    components: { AddOrgPruductPay},
    data() {
      return {
        AddMoneyPayVisible:false,
        tableData:[],
        total:0,
        pageNumber:1,
        pageSize:40,
        queryParams:{},
        activeIndex:"1",
        curGoodsType:3//3组织内部套餐  7星舰内部套餐 10电商内部套餐
        
      };
    },
    async mounted() {
        this.getData()
    },
    methods: {
        getData() {
            this.$https('queryGoods', {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                goodsType:this.curGoodsType,
                ...this.queryParams
            }).then(res => {

                res.data.records.forEach((val)=>{
                    val.goodsOrgVip.realPrice = val.goodsOrgVip.realPrice/100
                    val.goodsOrgVip.originalPrice = val.goodsOrgVip.originalPrice/100
                    Object.assign(val, val.goodsOrgVip)
                })
                this.tableData = res.data.records

                this.total = parseInt(res.data.total)

            })
        },
        addClickBtn(){
            this.AddMoneyPayVisible = true
            this.$nextTick(()=>{
                this.$refs.AddMoneyPayRef.start()
            })
        },
        handleSizeChange(size) {
            this.pageSize = size
            this.getData()
        },
        handleCurrentChange(num) {
            this.pageNumber = num
            this.getData()
        },
        editBtn(item){
            this.AddMoneyPayVisible = true
            this.$nextTick(()=>{
                item.goodsOrgVip.status = item.status
                this.$refs.AddMoneyPayRef.start(item.goodsOrgVip, item.id)
            })
        },
        handleSelect(index){
            this.activeIndex = index
            if(this.activeIndex == "1"){
                this.curGoodsType = 3
            }else if(this.activeIndex == "2"){
                this.curGoodsType = 7
            }else if(this.activeIndex == "3"){
                this.curGoodsType = 10
            }
            this.curGoodsType
            this.pageNumber = 1
            this.getData()
        },
        getModelNameList(models){
            // console.log("models", models);
            var arr = []
            for(let key in models){
                var item = models[key]
                var res = this.modelLibrary.find((val)=>{
                    return val.modelValue == item.modelValue
                })
                console.log(res);
                if(res){
                    arr.push(res.name)
                }
            }
            return "【" + arr.join("】, 【") + "】"
        }
    },
  };
</script>
  
<style scoped >
.dialogWrap{
    padding: 20px 0 20px 80px;
    box-sizing: border-box;
}
.radioWrap{
    padding: 10px 0;
}
.yes{
    color: rgb(75, 167, 0);
}
.no{
    color: rgb(255, 79, 79);
}
.head-opt{
    margin-bottom: 10px;
}
</style>
  